module.exports = __webpack_public_path__ + "static/img/2.9068ff14.png";